const portland = portland || {};

(function ($, history, URLSearchParams) {

	portland.aggregate = {

		elem: {
			$articles: $('.article-grid'),
			$loading: $('.loader'),
			$pagination: $('.pagination'),
			$results: $('.results')
		},

		mql: {
			large: window.matchMedia('(min-width: 640px)')
		},

		// Filters

		dataSrc:  $('.results').data('src'),
		documentRoot: '/portlandmagazineredesign',
		paginator: '/_files/_data/paginator.php',
		//documentRoot: '/data',
		//paginator: '/' + $('.results').data('src'),
		pagesize: 12,

		results: '',

		filters: {
			pageindex: 0
		},

		// Initialize Function
		init: function () {
			this.getQuery();
			this.setQuery(false, false);
			window.onpopstate = this.filterState;
		},


		// Equalize Heights of item in article grids
		articleHeights: function() {
			portland.aggregate.elem.$articles.each( function() {
				portland.aggregate.equalizeHeights($(this).find('.introduction__category'));
				portland.aggregate.equalizeHeights($(this).find('.introduction__episode'));
				portland.aggregate.equalizeHeights($(this).find('.introduction__title'));
				portland.aggregate.equalizeHeights($(this).find('.introduction__summary'));
				portland.aggregate.equalizeHeights($(this).find('.introduction__credit-list'));
			});
		},

		equalizeHeights: function(selector) {
			selector.removeAttr('style');
			if (portland.aggregate.mql.large.matches) {
				let tallest = 0;
				selector.each(function() {
					if ($(this).innerHeight() > tallest) {
						tallest = $(this).innerHeight();
					}
				});
				selector.innerHeight(tallest);
			};
		},

		// Build a querystring from a filter object
		buildQuery: function() {
			let data = portland.aggregate.filters;
			let query = [];
			for (let key in data) {
				if (data.hasOwnProperty(key)) {
					if (Array.isArray(key)) {
						data[key] = key.toString();
					}
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
				}
			}
			query = query.join('&').replace(/%2C/g, ',');
			return query;
		},

		// Pagination filtering
		filterPagination: function(e) {
			e.preventDefault();
			portland.aggregate.filters['pageindex'] = e.currentTarget.hash.substr(1);
			portland.aggregate.setQuery(true, true);
		},

		// PopState filtering
		filterState: function() {
			portland.aggregate.getQuery();
			portland.aggregate.setQuery(false, false);
		},

		// Get Data
		getData: function(query) {
			let deferred = $.Deferred();
			$.ajax({
				url: portland.aggregate.documentRoot + portland.aggregate.paginator + '?datasrc=' + portland.aggregate.dataSrc,
				method: 'GET',
				data: query,
				dataType: 'html',
				success: function(data) {
					deferred.resolve(data);
				},
				error: function(jqXHR, textStatus, errorThrow) {
					console.log(jqXHR, errorThrow);
					deferred.reject(textStatus);
				}
			});
			return deferred.promise();
		},

		// Get filters from existing query string
		getQuery: function() {
			if (window.location.search.length > 0) { 
				let searchParams = new URLSearchParams(window.location.search);
				searchParams.forEach(function (value,key) {
					if(value !== '') {
						if (Array.isArray(portland.aggregate.filters[key])) {
							portland.aggregate.filters[key] = [];
							value = value.split(',');
							portland.aggregate.filters[key] = value;
						} else {
							portland.aggregate.filters[key] = value;
						}
					}
				});
			}
		},

		// Build pagination
		renderPagination: function() {
			let items = [];
			let filters = portland.aggregate.filters;
			let current = parseInt(filters['pageindex']);
			let max = Math.ceil(parseInt(portland.aggregate.results[0].TotalCount) / parseInt(portland.aggregate.pagesize)) - 1;
			let output = '<div class="pagination__column column small-12 large-10 large-push-1"><ul class="pagination__list">';
			// Push all the items we need at a minimum: first, current, last, and output bracketing current
			items.push(0, current - 1, current, current + 1, max);
			// When the values are close to first or last, push some extra options to ensure that we always have at least four options showing
			if (current < 2) {
				items.push(2);
			}
			if (current > (max - 1)) {
				items.push(max - 2);
			}
			// Filter out results that are less than zero, or greater than max, then sort
			items = items.filter(function(x){ return x > -1 });
			items = items.filter(function(x){ return x <= max });
			items.sort(function(a, b){return a-b});

			if(current !== 0) {
				output += '<li class="pagination__item pagination__item--prev"><a href="#' + (current - 1) + '" rel="prev" class="pagination__button" aria-label="Previous Page"><svg class="icon icon-arrow-left" focusable="false"><use xlink:href="#icon-arrow-left"></use></svg></a></li>';
			}
			for(let i = 0; i < items.length; i = i + 1) {
				if((i === 0) || (items[i] !== items[i - 1])) {
					if((i > 0) && ((items[i] - items[i - 1]) > 1)) {
						output += '<li class="pagination__item">...</li>';
					}
					if(items[i] === current) {
						output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link pagination__link--active">' + (items[i] + 1) + '</a></li>';
					} else {
						output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link">' + (items[i] + 1) + '</a></li>';
					}
				}
			}
			if(current !== max) {

				output += '<li class="pagination__item pagination__item--next"><a href="#' + (current + 1) + '" rel="next" class="pagination__button" aria-label="Next Page"><svg class="icon icon-arrow-right" focusable="false"><use xlink:href="#icon-arrow-right"></use></svg></a></li>';
			}
			output += '</ul></div>';
			portland.aggregate.elem.$pagination.html(output);
			$('.pagination__button, .pagination__link').on('click', portland.aggregate.filterPagination);
		},

		renderResults: function() {
			portland.aggregate.elem.$loading.hide();
			if((portland.aggregate.results !== '') && (portland.aggregate.results[0].TotalCount > 0)) {
				let output = '';
				portland.aggregate.results[0].Results.forEach( function(item) {
					output += '<div class="card text-center medium-text-left"><div class="card-image"><div class="image" style="background-image: url(\'' + portland.aggregate.documentRoot + item.image.src + '\')" aria-label="' +  item.image.alt +'" role="img"></div>';
					switch(item.type) {
						case 'Photo Essay':
							output += '<svg class="icon icon-photo" focusable="false"><use xlink:href="#icon-photo"></use></svg>';
							break;
						case 'Podcast':
							output += '<svg class="icon icon-podcast" focusable="false"><use xlink:href="#icon-podcast"></use></svg>';
							break;
						case 'Video':
							output += '<svg class="icon icon-video" focusable="false"><use xlink:href="#icon-video"></use></svg>';
					}
					output += '</div><div class="introduction">';
					if(item.type === 'Podcast') {
						output += '<div class="introduction__episode h5" style="height: 23px;">Episode ' + item.episodeNumber + ' | ' + item.releaseDate + '</div>';
					}
					output += '<h2 class="introduction__title h3">' + item.title + '</h2><p class="introduction__summary">' + item.summary + '</p><ul class="introduction__credit-list">';
					if(item.credits[0].length > 1) {
						item.credits.forEach( function(credit) {
							output += '<li class="introduction__credit"><span class="introduction__credit-type">' + credit[0] + '</span> <span class="introduction__credit-name">' + credit[1] + '</span></li>';
						});
					}
					output += '</ul></div><a href="' + portland.aggregate.documentRoot + item.url + '" class="card__link" aria-label="Read \'' + item.title + '\'"></a></div>';
				});
				portland.aggregate.elem.$results.html(output).fadeIn();
				portland.aggregate.articleHeights();
				if(portland.aggregate.results[0].TotalCount > portland.aggregate.pagesize) {
					portland.aggregate.renderPagination();
					portland.aggregate.elem.$pagination.fadeIn();
				}
			} else {
				portland.aggregate.elem.$results.html('<p class="article-grid__no-results h4 text-center">No matching articles were found.</p>').fadeIn();
			}
		},

		// Set the current URL to 
		setQuery: function (reposition, push) {
			let query = portland.aggregate.buildQuery();
			let dataObj = portland.aggregate.getData(query);
			if (reposition === true) {
				$('html, body').animate({ scrollTop: $('.results').offset().top }, 400);
			}
			if (push === true) {
				history.pushState(null, '', '?' + query);
			} else {
				history.replaceState(null, '', '?' + query);
			}
			portland.aggregate.elem.$loading.show();
			portland.aggregate.elem.$results.fadeOut().empty();
			portland.aggregate.elem.$pagination.fadeOut().empty();
			$.when(dataObj)
				.done(function(data) {
					setTimeout(function() {
						if(data !== '') {
							portland.aggregate.results = JSON.parse(data);
						} else {
							portland.aggregate.results = ''
						}
						portland.aggregate.renderResults();
					}, 500);
				})
				.fail(function () {
					console.log('API ERROR: No results were returned')
				});
		}

	};

}(window.jQuery, window.history, window.URLSearchParams));

const ready = () => {
	portland.aggregate.init();
};

window.addEventListener('DOMContentLoaded', ready, false);
$(document).foundation();
